import {store} from './../../redux/';
import { call, put } from 'redux-saga/effects';
import { url } from './../../services/Url';
import CONSTANTS from '../../util/constants';
import APICallingService from '../../services/APICallingService';

const getDoorsLogAPI = (action) => {

    let urlLog = url.getDoorLogs + "/" + action.payload.value.door_id
    return APICallingService.sendRequestForGet(urlLog, (res) => {
    }, true);

}

function* getDoorsLog(action) {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getDoorsLogAPI, action);
        if (response && response?.callBackStatus.toLowerCase() == 'success') {
            yield put({
                type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_LOG_MANAGEMENT_API_SUCCESS, payload: { value: response.data }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get door log');
                yield put({ type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_LOG_MANAGEMENT_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }


    }
    catch (e) {
        yield put({ type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_LOG_MANAGEMENT_API_SUCCESS, payload: { value: 'Failed' } });
    }


}


const getDoorsForMoveAPI = () => {
    return APICallingService.sendRequestForGet(url.getDoorsForMoves, (res) => {
    }, true);
}

function* getDoorsForMoves() {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getDoorsForMoveAPI);
        if (response && response?.callBackStatus.toLowerCase() == 'success') {
            yield put({
                type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_FOR_MOVE_MANAGEMENT_API_SUCCESS, payload: { value: response.data }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get doors');
                yield put({ type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_FOR_MOVE_MANAGEMENT_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }
    }
    catch (e) {
        yield put({ type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_FOR_MOVE_MANAGEMENT_API_SUCCESS, payload: { value: 'Failed' } });
    }
}

const getDoorsAPI = () => {
    return APICallingService.sendRequestForGet(url.getDoors, (res) => {
    }, true);
}

function* getDoors() {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getDoorsAPI);
        if (response && response?.callBackStatus.toLowerCase() == 'success') {
            yield put({
                type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_API_SUCCESS, payload: { value: response.data }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get doors')
                yield put({ type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }
    }
    catch (e) {
        yield put({ type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_API_SUCCESS, payload: { value: 'Failed' } });
    }


}

const getDoorsByIdFun = (value) => {
    let urlGet = url.getDoors + value.id.toString();
    return APICallingService.sendRequestForGet(urlGet, (res) => {
    }, true);
}

function* getDoorsById(action) {
    try {
        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getDoorsByIdFun, action.payload.value);
        if (response && response?.callBackStatus.toLowerCase() == 'success') {
            yield put({
                type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORSBYID_MANAGEMENT_API_SUCCESS, payload: { value: response.data }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get doors')
                yield put({ type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORSBYID_MANAGEMENT_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }
    }
    catch (e) {
        yield put({ type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_API_SUCCESS, payload: { value: 'Failed' } });
    }


}

const createDoorsAPI = (value) => {
    let payload = {
        "division_id": value.divisionId,
        "doorType": value.doorType ? value.doorType.value : 'Receiving',
        "number": value.number
    }

    return APICallingService.sendRequestForPostWithAuth(url.addDoor, payload, false, (res) => {
    }, true);
}

function* createDoors(action) {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(createDoorsAPI, action.payload.value);

        if (response && response?.callBackStatus.toLowerCase() == 'success') {

            alert('Door no ' + response.data.number + " Added Successfully")

            yield put({
                type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_FOR_MOVE_MANAGEMENT_API_CALL
            })
            yield put({
                type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.ADD_DOORS_API_SUCCESS, payload: { value: response?.callBackStatus }
            })

        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to add door')
                yield put({
                    type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.ADD_DOORS_API_SUCCESS, payload: { value: response?.callBackStatus }
                })
            }
        }

    }
    catch (e) {
        yield put({ type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.ADD_DOORS_API_SUCCESS, payload: { value: 'Failed' } });
    }

}


const editDoorsAPI = (value) => {

    let urlEdit = url.editDoor + value.door_id.toString();

    let payload = {
        "doorType": value.doorType.value,
        "number": value.number
    }

    return APICallingService.sendRequestForPut(payload, urlEdit, (res) => {
    }, true);

}

function* editDoors(action) {


    try {



        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(editDoorsAPI, action.payload.value);

        if (response && response != null) {


            alert('Doors no ' + action.payload.value.number + " Updated Successfully")

            yield put({
                type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_FOR_MOVE_MANAGEMENT_API_CALL
            })

        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to update door')
                yield put({ type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.EDIT_DOORS_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }
    }
    catch (e) {
        yield put({ type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.EDIT_DOORS_API_SUCCESS, payload: { value: 'Failed' } });
    }

}

export { editDoors, createDoors, getDoors, getDoorsById, getDoorsForMoves, getDoorsLog };
